<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  Marquee(:class="{ 'd-none': !whiteLabel }")
  toolBar
  .content-center
    .pagepanel
      .page-group.contact
        .card
          //- .description
          //-   p {{ $t("message.contactus_title1") }}
          .info-row
            .icon
              i.far.fa-envelope
            .info-wrap
              h5 {{ $t("ui.gmail") }}
              p.info
                a.text-decoration-none(href="mailto:wbetcs@gmail.com") wbetcs@gmail.com
          //- .info-row
          //-   .icon
          //-     i.fab.fa-skype
          //-   .info-wrap
          //-     h5 {{ $t("ui.skype") }}
          //-     p.info wbetcs@gmail.com
          //- .info-row
          //-   .icon
          //-     i.fab.fa-weixin
          //-   .info-wrap
          //-     h5 {{ $t("ui.wechat") }}
          //-     p.info +63 956 053 2283
          .info-row
            .icon
              i.fab.fa-telegram
            .info-wrap
              h5 {{ $t("ui.telegram") }}
              p.info
                a.text-decoration-none(href="https://t.me/+639560532283" target="_blank") +63 956 053 2283
          .info-row
            .icon
              i.fas.fa-phone-alt
            .info-wrap
              h5 {{ $t("ui.contact_number") }}
              p.info
                a.text-decoration-none(href="tel:+639560532283") +63 956 053 2283
          //- .info-row
          //-   .icon
          //-     i.fas.fa-comments
          //-   .info-wrap.pt-3
          //-     h5 
          //-       a(href="https://docs.google.com/forms/d/16N4aJg8nc2c3yqiAMG1byLhbmUnyfaG74_BABeo-2aY/viewform?edit_requested=true" target="_blank") {{ $t('ui.feedback') }}
  footerNav
</template>


<script>
import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";
import Marquee from "@/components/mobile/mainPanelControl/marquee";
import config from "@/config";

export default {
  components: {
    toolBar,
    footerNav,
    Marquee
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    }
  },
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    }
  }
};
</script>
